import { CLICK_VS_DRAG_PX } from "./scenePickerConstants";

export function createSceneRmbDocumentTracking({
  canvas,
  sceneRmbContextAnchorRef,
  sceneRmbContextDraggedRef,
}) {
  let attached = false;

  function detach() {
    if (!attached) return;
    attached = false;
    const doc = canvas.ownerDocument;
    doc.removeEventListener("pointermove", onDocumentPointerMove, true);
    doc.removeEventListener("pointerup", onDocumentPointerUpOrCancel, true);
    doc.removeEventListener("pointercancel", onDocumentPointerUpOrCancel, true);
  }

  function onDocumentPointerMove(event) {
    const anchor = sceneRmbContextAnchorRef.current;
    if (!anchor) return;
    if (
      Math.abs(event.clientX - anchor.x) >= CLICK_VS_DRAG_PX ||
      Math.abs(event.clientY - anchor.y) >= CLICK_VS_DRAG_PX
    ) {
      sceneRmbContextDraggedRef.current = true;
    }
  }

  function onDocumentPointerUpOrCancel(event) {
    if (event.type === "pointerup" && event.button !== 2) return;
    detach();
  }

  function attach() {
    if (attached) return;
    attached = true;
    const doc = canvas.ownerDocument;
    doc.addEventListener("pointermove", onDocumentPointerMove, true);
    doc.addEventListener("pointerup", onDocumentPointerUpOrCancel, true);
    doc.addEventListener("pointercancel", onDocumentPointerUpOrCancel, true);
  }

  return { attach, detach };
}
